import { Edit, Trash2 } from "lucide-react";

const ActionButtons = ({
  onEdit,
  onDelete,
  editText = "Edit",
  deleteText = "Delete",
  EditIcon = Edit,
  className = "",
}) => {
  const buttonClass = `
    flex items-center justify-center gap-2
    w-full sm:w-auto
    px-3 py-2 sm:px-4 lg:px-5
    rounded-xl
    text-xs sm:text-sm
    font-medium
    text-white
    transition duration-200
    whitespace-nowrap
  `;

  return (
    <div
      className={`flex flex-col sm:flex-row gap-2 sm:gap-3 w-full sm:w-auto ${className}`}
    >
      {onEdit && (
        <button
          onClick={onEdit}
          className={`${buttonClass} bg-green-600 hover:bg-green-500`}
        >
          <EditIcon size={16} />
          <span>{editText}</span>
        </button>
      )}

      {onDelete && (
        <button
          onClick={onDelete}
          className={`${buttonClass} bg-red-600 hover:bg-red-500`}
        >
          <Trash2 size={16} />
          <span>{deleteText}</span>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;